




























import { defineComponent } from '@vue/composition-api';
import { SelfBuildingSquareSpinner } from 'epic-spinners';

export default defineComponent({
    name: 'LoadingModal',
    components: {
        SelfBuildingSquareSpinner,
    },
    props: {
        message: {
            type: String,
            required: false,
        },
    },
});
